import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cache from '@/utils/cache'

export const useNavlistStore = defineStore('navlist', () => {
    const list = ref(Cache.get('navList'))

    const setList = (e) => {
        list.value = e
    }
    const del = () => {
        list.value = {}
    }
    return { list, setList, del }
})
